module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.7f24716.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.eot
// module id = Fl5g
// module chunks = 10